import React, { useState } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import ListingCard from "../ListingCard";
import "./ProductList.css";
import { useParams } from "react-router-dom";

function ProductList({ products }) {
  const { type } = useParams();
  const [selectedTypes, setSelectedTypes] = useState([
    "residence",
    "villa",
    "store",
  ]);

  const typesText = {
    residence: "Rezidans",
    villa: "Villa",
    store: "Dükkan",
    all: "Tüm",
  };

  const handleFilterChange = (type) => {
    setSelectedTypes((prevSelectedTypes) =>
      prevSelectedTypes.includes(type)
        ? prevSelectedTypes.filter((t) => t !== type)
        : [...prevSelectedTypes, type]
    );
  };

  // Her kategoriye ait ürün sayısını hesapla
  const categoryCounts = {
    residence: products.filter(
      (product) => product.details?.buldingType?.toLowerCase() === "residence"
    ).length,
    villa: products.filter(
      (product) => product.details?.buldingType?.toLowerCase() === "villa"
    ).length,
    store: products.filter(
      (product) => product.details?.buldingType?.toLowerCase() === "store"
    ).length,
  };

  // Filtrelenmiş ürünleri hesapla
  const filteredProducts = products.filter((product) => {
    const productType = product.details?.buldingType?.toLowerCase();

    if (!productType) return false;

    // Eğer "all" ise kullanıcının seçtiği filtrelere göre ürünleri göster
    if (type === "all") {
      return selectedTypes.length === 0 || selectedTypes.includes(productType);
    }

    // Eğer "all" değilse sadece o kategoriye ait ürünleri göster
    return productType === type.toLowerCase();
  });

  return (
    <div className="product-list-container container-xl text-center py-5">
      <h1>
        {typesText[type] === "Rezidans"
          ? "DAİRE & REZİDANS"
          : typesText[type] === "Villa"
          ? "VİLLA"
          : typesText[type] === "Dükkan"
          ? "DÜKKAN & MAĞAZA"
          : "TÜM PROJELER"}
      </h1>

      {/* Filtre Bölgesi */}
      {type === "all" && (
        <div className="filters">
          <div className="filter-item">
            <input
              type="checkbox"
              id="rezidans"
              checked={selectedTypes.includes("residence")}
              onChange={() => handleFilterChange("residence")}
            />
            <label htmlFor="rezidans">
              <i className="fa-solid fa-building"></i> Rezidans (
              {categoryCounts.residence})
            </label>
          </div>
          <div className="filter-item">
            <input
              type="checkbox"
              id="villa"
              checked={selectedTypes.includes("villa")}
              onChange={() => handleFilterChange("villa")}
            />
            <label htmlFor="villa">
              <i className="fa-solid fa-house-flood-water"></i> Villa (
              {categoryCounts.villa})
            </label>
          </div>
          <div className="filter-item">
            <input
              type="checkbox"
              id="dukkankategori"
              checked={selectedTypes.includes("store")}
              onChange={() => handleFilterChange("store")}
            />
            <label htmlFor="dukkankategori">
              <i className="fa-solid fa-store"></i> Dükkan & Mağaza (
              {categoryCounts.store})
            </label>
          </div>
        </div>
      )}

      {/* Ürün Listesi */}
      <SwitchTransition>
        <CSSTransition
          key={filteredProducts.map((product) => product.id).join(",")}
          timeout={500}
          classNames="list"
        >
          <div className="product-list">
            {filteredProducts && filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <ListingCard key={product.id} listing={product} />
              ))
            ) : (
              <p className="no-products">Proje bulunamadı.</p>
            )}
          </div>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
}

export default ProductList;
